import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  BOOKS_SIMILAR_BOOKS_SET_DATA,
  BOOKS_SIMILAR_BOOKS_RESET_DATA,
} from 'rebook/apps/books/constants';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const { similarBooks: currentState } = getState();

    const { bookSlug } = match.params;

    let newState = {
      bookSlug,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    else if (currentState.bookList) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.book) {
      await dispatch(fetchBook(match));
    }

    if (!newState.bookList) {
      await dispatch(fetchSimilarBooks());
    }
  };
}

export function fetchBook(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { bookSlug } = match.params;
    const url = `/api/books/s-${bookSlug}/`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({ book: data }));
      })
      .catch(
        ({ data, resp, error }) => {
          if (resp.status === 404) {
            dispatch(Error404Actions.show());
          }
          else {
            Raven.captureMessage('failed to similar book list book due to server error', {
              level: 'error',
              extra: {
                status: resp.status,
                response: data,
                error,
              },
            });
            throw new Error('failed to load similar book list book detail due to server error');
          }
        }
      );
  };
}

export function fetchSimilarBooks() {
  return async(dispatch, getState) => {
    const { ssr, similarBooks } = getState();
    const { book } = similarBooks;

    const url = `/api/book-recommend/${book.id}/`;

    return await fetchQuery(url, { apiVersion: 3, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({
          bookList: data.books,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load similar book list book due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load similar book list book detail due to server error');
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { similarBooks } = getState();
    const { book } = similarBooks;

    const title = `Книги похожие на «${book.name}»`;

    const description = `Читайте книги, похожие на «${book.name}». ` +
      `Более 10 книг похожих на «${book.name}» онлайн книг в электронной библиотеке MyBook.`;

    dispatch(SeoActions.setData({
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { book } = payload;
    dispatch({
      type: BOOKS_SIMILAR_BOOKS_SET_DATA,
      payload,
    });
    if (book) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: BOOKS_SIMILAR_BOOKS_RESET_DATA,
    });
  };
}
